import React from 'react';
import { Hero } from './components/sections/Hero';
import { InvisiblePain } from './components/sections/InvisiblePain';
import { Mechanism } from './components/sections/Mechanism';
import { Founder } from './components/sections/Founder';
import { ValueStack } from './components/sections/ValueStack';
import { Objections } from './components/sections/Objections';
import { Testimonials } from './components/sections/Testimonials';
import { ScarcityClose } from './components/sections/ScarcityClose';
import { ReserveForm } from './components/sections/ReserveForm';
import { MiamiGuide } from './components/sections/MiamiGuide';
import { Faq } from './components/sections/Faq';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-[var(--white)] font-['Nunito_Sans',sans-serif] text-1a1a2e antialiased" data-id="element-0" data-mp="2whxabqim5ie4">
      <main data-id="element-1" data-mp="28s2y9b64bxux">
        <Hero data-id="element-2" data-mp="23vci6nubd29i" />
        <InvisiblePain data-id="element-3" data-mp="23vunsb2v8su3" />
        <Mechanism data-id="element-4" data-mp="23u9qidp62vsj" />
        <Founder data-id="element-5" data-mp="23v2r0wxj8p28" />
        <ValueStack data-id="element-6" data-mp="23ti8k5ohswkq" />
        <Objections data-id="element-7" data-mp="3ik7fce9tu7pl" />
        <Testimonials data-id="element-8" data-mp="3ikqytzf4l45q" />
        <ScarcityClose data-id="element-9" data-mp="3ijfvu1ti80fo" />
        <ReserveForm data-id="element-10" data-mp="3ihuyk4ft23e4" />
        <MiamiGuide data-id="element-11" data-mp="3mlavl1vse5rc" />
        <Faq data-id="element-12" data-mp="3mkrc3gqhn9b7" />
      </main>
      <Footer data-id="element-13" data-mp="3mjzrt22ccy08" />
    </div>;
}